<wilson-basic-search-filter
  [label]="showLabel && label"
  [debounceTime]="debounceTime"
  [placeholder]="placeholder"
  [value]="currentSearchTerm$ | async"
  (inputChanged)="updateSearchTermAndSaveSelected($event)"
  (isFocusing)="isFocusing = $event"
></wilson-basic-search-filter>
